import Immutable from 'seamless-immutable';
import { PARKINGS_TYPES } from './actions';
import { createReducer } from '../../libs/saga-utils';

const DEFAULT_STATE = {
  parkingsLoaded: false,
  parkings: [],
  activeParking: undefined,
  isCreating: false,
  isUpdating: false,
  isDeleting: false,
  meta: {},

  filters: {
    'page[number]': 1,
    'page[size]': 10,
    sort: '-updated_at'
  },
  eventId: 1
};

const ACTIONS = {
  [PARKINGS_TYPES.CREATE_SUCCESS]: createSuccess,
  [PARKINGS_TYPES.CREATE_FAILURE]: createFailure,
  [PARKINGS_TYPES.CREATE_REQUEST]: createRequest,

  [PARKINGS_TYPES.LOAD_ALL_SUCCESS]: loadAllSuccess,
  [PARKINGS_TYPES.LOAD_ALL_FAILURE]: loadAllFailure,
  [PARKINGS_TYPES.LOAD_ALL_REQUEST]: loadAllRequest,

  [PARKINGS_TYPES.LOAD_SUCCESS]: loadSuccess,
  [PARKINGS_TYPES.LOAD_FAILURE]: loadFailure,
  [PARKINGS_TYPES.LOAD_REQUEST]: loadRequest,

  [PARKINGS_TYPES.UPDATE_SUCCESS]: updateSuccess,
  [PARKINGS_TYPES.UPDATE_FAILURE]: updateFailure,
  [PARKINGS_TYPES.UPDATE_REQUEST]: updateRequest,

  [PARKINGS_TYPES.DELETE_SUCCESS]: deleteSuccess,
  [PARKINGS_TYPES.DELETE_FAILURE]: deleteFailure,
  [PARKINGS_TYPES.DELETE_REQUEST]: deleteRequest,

  [PARKINGS_TYPES.UPDATE_FILTERS]: updateFilters,
  [PARKINGS_TYPES.UPDATE_EVENT]: updateEvent,
  [PARKINGS_TYPES.RESET_ERRORS]: resetErrors,
  [PARKINGS_TYPES.RESET_ACTIVE]: resetActive
};

// CREATE
function createRequest(state, { payload }) {
  return state.merge({
    isCreating: true,
    errors: {}
  });
}

function createSuccess(state, { payload }) {
  return state.merge({
    isCreating: false,
    errors: {}
  });
}

function createFailure(state, { payload }) {
  return state.merge({
    isCreating: false,
    errors: payload.response.data.errors
  });
}

// LOAD_ALL
function loadAllRequest(state, { payload }) {
  return state.merge({
    errors: {}
  });
}

function loadAllSuccess(state, { payload }) {
  const parkings = payload.parkings.data;
  return state.merge({
    parkings,
    parkingsLoaded: true,
    meta: payload.parkings.meta,
    errors: {}
  });
}

function loadAllFailure(state, { payload }) {
  return state.merge({
    errors: payload.response.data.errors
  });
}

// LOAD
function loadRequest(state, { payload }) {
  return state.merge({
    errors: {}
  });
}

function loadSuccess(state, { payload }) {
  return state.merge({
    activeParking: payload.parking,
    errors: {}
  });
}

function loadFailure(state, { payload }) {
  return state.merge({
    errors: payload.response.data.errors
  });
}

// UPDATE
function updateRequest(state, { payload }) {
  return state.merge({
    isUpdating: true,
    errors: {}
  });
}

function updateSuccess(state, { payload }) {
  return state.merge({
    isUpdating: false,
    errors: {}
  });
}

function updateFailure(state, { payload }) {
  return state.merge({
    isUpdating: false,
    errors: payload.response.data.errors
  });
}

// DELETE
function deleteRequest(state, { payload }) {
  return state.merge({
    isDeleting: true,
    errors: {}
  });
}

function deleteSuccess(state, { payload }) {
  return state.merge({
    isDeleting: false,
    errors: {}
  });
}

function deleteFailure(state, { payload }) {
  return state.merge({
    isDeleting: false,
    errors: payload.response.data.errors
  });
}

// FILTERS
function updateFilters(state, { payload }) {
  const { filters } = payload;

  return state.merge({
    filters
  });
}

function updateEvent(state, { payload }) {
  const { eventId } = payload;
  return state.merge({
    eventId
  });
}

// ERRORS
function resetErrors(state, { payload }) {
  return state.merge({
    errors: {}
  });
}

function resetActive(state, { payload }) {
  return state.merge({
    activeParking: undefined
  });
}

const parkingsReducer = createReducer(Immutable(DEFAULT_STATE), ACTIONS);

export default parkingsReducer;
